import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationConversionReasonEntity } from '../../../domain/entities/investigation-conversion-reason.entity';

export interface GetInvestigationConversionReasonsResult {
  reasons: InvestigationConversionReasonEntity[];
}

@Injectable({ providedIn: 'root' })
export class GetInvestigationConversionReasonsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _toast = inject(ToastProvider);

  public execute(): Observable<GetInvestigationConversionReasonsResult> {
    return this._repository.getConversionReasons().pipe(
      map((reasons) => ({ reasons })),
      catchError((error) => {
        this._toast.error('Failed to load conversion reasons', 'Please refresh and try again.');
        return throwError(() => error);
      }),
    );
  }
}
